module.exports = __webpack_public_path__ + "static/media/grade5.a4393fae.jpg";